import { DataTable } from 'components/DataTable/DataTable';
import { ReadField } from 'components/ReadField';
import type { BimContractData } from 'gql/graphql';
import { GridItem, CollapseGroup } from 'uikit';

import type React from 'react';
import { useMemo } from 'react';

import { bimContractPriceTabStyle } from '../../BimContractEdit/components/BimContractEditPriceForm';
import { getInflation } from '../../hooks/useBimContractFormData';
import { useBimConversionIndicesColumns } from '../../hooks/useBimConversionIndicesColumns';
import { useBimSeasonsInflationColumns } from '../../hooks/useBimSeasonsInflationColumns';

import { BimContractReadLimitedCosts } from './BimContractReadLimitedCosts';

interface IBimContractReadPriceForm {
    data?: BimContractData | null;
}

export const BimContractReadPriceForm: React.FC<IBimContractReadPriceForm> = (props) => {
    const { data } = props;
    const { conversionIndices, constructionTypes } = data || {};

    const seasonsInflationBySeasons = useMemo(() => getInflation(data as BimContractData), [data]);

    const conversionIndicesByConstructionTypes = useMemo(
        () =>
            constructionTypes?.map((type, index) => ({
                id: String(type.id),
                constructionType: type,
                coefficients: { kemm: 0, keqp: 0, kmtr: 0, knr: 0, kozp: 0, kpir: 0, ksp: 0 },
                constructionTypeId: type.id,
                index,
            })),
        [constructionTypes],
    );

    const conversionIndicesColumns = useBimConversionIndicesColumns();

    const seasonColumns = useBimSeasonsInflationColumns();

    const items = useMemo(
        () => [
            {
                label: 'Индексы перевода в текущий уровень цен',
                content: (
                    <DataTable
                        borderBetweenRows
                        outerBorders
                        columns={conversionIndicesColumns}
                        data={conversionIndices || conversionIndicesByConstructionTypes || []}
                    />
                ),
            },
            {
                label: 'Сезон',
                content: (
                    <DataTable
                        borderBetweenRows
                        outerBorders
                        columns={seasonColumns}
                        data={seasonsInflationBySeasons || []}
                    />
                ),
            },
            {
                label: 'Лимитированные затраты',
                content: <BimContractReadLimitedCosts data={data} />,
            },
        ],
        [
            conversionIndices,
            conversionIndicesByConstructionTypes,
            conversionIndicesColumns,
            data,
            seasonColumns,
            seasonsInflationBySeasons,
        ],
    );

    const opened = useMemo(() => items.map((_, index) => index), [items]);

    return (
        <div style={bimContractPriceTabStyle}>
            <GridItem>
                <ReadField label="Базис поставки" value={data?.supplyBasis} />
            </GridItem>
            <GridItem>
                <CollapseGroup items={items} opened={opened} />
            </GridItem>
        </div>
    );
};

BimContractReadPriceForm.displayName = 'BimContractReadPriceForm';
